function normalizeParticipantEvidenceText(value = "") {
  return String(value || "")
    .replace(/[’‘]/g, "'")
    .replace(/\s+/g, " ")
    .trim();
}

function blankQuotedSpan(value = "") {
  return String(value || "").replace(/[^\r\n]/g, " ");
}

const OTHER_PERSON_QUOTE_CUE = /(?:\b(?:she|he|they)\s+(?:said|says|replied|responded|wrote|writes|texted|messaged|told\s+me|asked\s+me)|\b(?:her|his|their)\s+(?:reply|response|answer|message|text|email|note)\s+(?:was|is|said|says|read|reads)|\b(?:the\s+)?(?:message|text|email|note)\s+from\s+(?:her|him|them)\s+(?:said|says|read|reads|was|is))\s*(?:that\s+)?(?:[,;:]|[-–—])?\s*$/i;
const PARTICIPANT_QUOTE_CUE = /(?:\bi\s+(?:said(?:\s+to\s+myself)?|told\s+myself|wrote|replied)|\bmy\s+(?:plan|decision|next\s+step|agreed\s+action)\s+(?:is|was)|\bi\s+(?:have\s+|'ve\s+)?decided(?:\s+to)?|\bwhat\s+i(?:'m|\s+am)\s+going\s+to\s+do\s+(?:is|was)|\bi(?:'m|\s+am)\s+going\s+to)\s*(?:that\s+)?(?:[,;:]|[-–—])?\s*$/i;

function quoteOwnership(value = "", openingIndex = 0, closingIndex = 0) {
  const text = String(value || "");
  const before = text.slice(0, openingIndex);
  const after = text.slice(closingIndex + 1);
  if (!before.trim() && /^[.!?]*$/.test(after.trim())) {
    return "participant";
  }
  const localPrefix = before.slice(-220);
  if (OTHER_PERSON_QUOTE_CUE.test(localPrefix)) return "other_person";
  if (PARTICIPANT_QUOTE_CUE.test(localPrefix)) return "participant";
  return "ambiguous";
}

function preserveParticipantQuotedSpan(value = "") {
  const characters = Array.from(String(value || ""));
  if (characters.length) {
    characters[0] = " ";
    characters[characters.length - 1] = " ";
  }
  return characters.join("");
}

function maskAttributedQuotedSpan(value, match, openingIndex) {
  const closingIndex = openingIndex + match.length - 1;
  return quoteOwnership(value, openingIndex, closingIndex) === "participant"
    ? preserveParticipantQuotedSpan(match)
    : blankQuotedSpan(match);
}

function maskStraightSingleQuotedSpeech(value = "") {
  const characters = Array.from(String(value || ""));
  const original = characters.join("");
  const openingContext = /[\s([{,:;—-]/;
  const closingContext = /[\s)\]},.!?;:—-]/;
  for (let index = 0; index < characters.length; index += 1) {
    if (
      characters[index] !== "'" ||
      (index > 0 && !openingContext.test(characters[index - 1]))
    ) continue;
    for (let closing = index + 1; closing < characters.length; closing += 1) {
      if (characters[closing] !== "'") continue;
      const apostropheInsideWord =
        /[a-z0-9]/i.test(characters[closing - 1] || "") &&
        /[a-z0-9]/i.test(characters[closing + 1] || "");
      const closesQuotedSpan =
        closing === characters.length - 1 ||
        closingContext.test(characters[closing + 1]);
      if (apostropheInsideWord || !closesQuotedSpan) continue;
      const ownership = quoteOwnership(original, index, closing);
      if (ownership === "participant") {
        characters[index] = " ";
        characters[closing] = " ";
      } else {
        for (let quoted = index; quoted <= closing; quoted += 1) {
          characters[quoted] = " ";
        }
      }
      index = closing;
      break;
    }
  }
  return characters.join("");
}

function maskCurlySingleQuotedSpeech(value = "") {
  const characters = Array.from(String(value || ""));
  const original = characters.join("");
  const closingContext = /[\s)\]},.!?;:—-]/;
  for (let index = 0; index < characters.length; index += 1) {
    if (characters[index] !== "‘") continue;
    for (let closing = index + 1; closing < characters.length; closing += 1) {
      if (characters[closing] !== "’") continue;
      const apostropheInsideWord = /[\p{L}\p{N}]/u.test(
        characters[closing - 1] || ""
      ) && /[\p{L}\p{N}]/u.test(characters[closing + 1] || "");
      const closesQuotedSpan =
        closing === characters.length - 1 ||
        closingContext.test(characters[closing + 1]);
      if (apostropheInsideWord || !closesQuotedSpan) continue;
      const ownership = quoteOwnership(original, index, closing);
      if (ownership === "participant") {
        characters[index] = " ";
        characters[closing] = " ";
      } else {
        for (let quoted = index; quoted <= closing; quoted += 1) {
          characters[quoted] = " ";
        }
      }
      index = closing;
      break;
    }
  }
  return characters.join("");
}

// This is intentionally bounded: nearby attribution cues preserve explicit
// participant-owned quotes and exclude other-person or ambiguous inline
// quotes. Quote ownership does not itself classify the preserved text as an
// action or completion.
function maskQuotedParticipantSpeech(value = "") {
  let text = String(value || "").replace(/\s+/g, " ").trim();
  [
    /“[^”\r\n]{0,600}”/g,
    /"[^"\r\n]{0,600}"/g,
  ].forEach((pattern) => {
    const source = text;
    text = text.replace(pattern, (match, openingIndex) => (
      maskAttributedQuotedSpan(source, match, openingIndex)
    ));
  });
  return maskStraightSingleQuotedSpeech(
    maskCurlySingleQuotedSpeech(text).replace(/[’‘]/g, "'")
  );
}

module.exports = {
  maskQuotedParticipantSpeech,
  normalizeParticipantEvidenceText,
};
